import { render, staticRenderFns } from "./EnviarTicket.vue?vue&type=template&id=4c087dd5&scoped=true"
import script from "./EnviarTicket.vue?vue&type=script&lang=js"
export * from "./EnviarTicket.vue?vue&type=script&lang=js"
import style0 from "./EnviarTicket.vue?vue&type=style&index=0&id=4c087dd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c087dd5",
  null
  
)

export default component.exports